import {
  useScenarioIdFromUrl,
  useShoppingBasketTokenFromUrl,
} from '#src/clientState/hooks';
import {
  PageTrackingProvider,
  ShoppingBasketPromoCodeProvider,
} from '#src/clientState/providers';
import { ErrorModalWrapperWithError } from '#src/components/ErrorModal/ErrorModalWrapper';
import { PageErrorEnum } from '#src/components/PageError';
import { EmptyManager } from '#src/components/ShoppingBasketIsEmptyChecker/ShoppingBasketIsEmptyChecker';
import { AlreadyProcessedManager } from '#src/components/ShoppingBasketStatusChecker';
import { PageError } from '#src/components/public';
import {
  AppErrorProvider,
  BlockingErrorBoundary,
  ErrorBoundary,
} from '@edreamsodigeo/frontend-core';
import React from 'react';

import { BrokenFlowModalTrackingProvider } from '../BrokenFlowModalTrackingProvider';
import { UPPDynamicTemplateProvider } from '../DynamicTemplateProvider';
import { LoginProvider } from '../LoginProvider';
import { PaymentComponentsABProvider } from '../ShoppingBasketPaymentComponentsProvider/ShoppingBasketPaymentComponentsProvider';
import { ShoppingBasketInfoProvider } from '../ShoppingBasketProvider';

const PRODUCT_INFO_PROVIDER_ERROR_NAME = 'ShoppingBasketInfoProvider';

export const PaymentPageProvider = ({ children, loginProps }) => {
  const shoppingBasketId = useShoppingBasketTokenFromUrl();
  const scenarioId = useScenarioIdFromUrl();
  return (
    <AppErrorProvider logService="/frontend-api">
      <ErrorBoundary
        name={PRODUCT_INFO_PROVIDER_ERROR_NAME}
        fallback={
          <PageError
            pageErrorStatus={PageErrorEnum.SHOPPING_BASKET_NOT_FOUND}
          />
        }
      >
        <ShoppingBasketInfoProvider shoppingBasketId={shoppingBasketId}>
          <PageTrackingProvider>
            <EmptyManager>
              <LoginProvider loginProps={loginProps}>
                <UPPDynamicTemplateProvider scenarioId={scenarioId}>
                  <ShoppingBasketPromoCodeProvider
                    shoppingBasketId={shoppingBasketId}
                  >
                    <AlreadyProcessedManager>
                      <BlockingErrorBoundary name="UPPBlockingErrorBoundary">
                        <PaymentComponentsABProvider>
                          {children}
                        </PaymentComponentsABProvider>
                      </BlockingErrorBoundary>
                    </AlreadyProcessedManager>
                  </ShoppingBasketPromoCodeProvider>
                </UPPDynamicTemplateProvider>
              </LoginProvider>
            </EmptyManager>
          </PageTrackingProvider>
        </ShoppingBasketInfoProvider>
      </ErrorBoundary>
      <BrokenFlowModalTrackingProvider>
        <ErrorModalWrapperWithError />
      </BrokenFlowModalTrackingProvider>
    </AppErrorProvider>
  );
};
